import eventQueue from '../queue';
function attachEventListeners() {
    eventQueue.on('another_allocation_expected', function (_a) {
        var fireClientEvent = _a.fireClientEvent;
        fireClientEvent('other_event', {
            name: 'another_allocation_expected',
            payload: [],
        });
    });
}
attachEventListeners();
